// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RatingHalfCircle_wrapper__OzUBv","halfCircle":"RatingHalfCircle_halfCircle__2iXZj","halfCircle--secondHalf":"RatingHalfCircle_halfCircle--secondHalf__3rRcZ"};